import * as React from 'react';
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    Party,
    Policy,
    POLICY_STATUS_MTC,
    ProductsEnum,
    resourcesHelper,
    Types,
    User
} from "@falcon/services";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {RouteComponentProps} from "react-router";
import {
    AutomaticRenewalCheckboxSection
} from "../../common/payments/paymentDetails/annual/AutomaticRenewalCheckboxSection";
import * as moment from "moment/moment";
import {AccountDetailsBanner} from "../../../../components/banners/AccountDetailsBanner";
import {PersonalDetailsWidget} from "../../../../components/accountDetails/PersonalDetailsWidget";
import {ContactDetailsWidget} from "../../../../components/accountDetails/ContactDetailsWidget";
import {ChangePasswordWidget} from "../../../../components/accountDetails/ChangePasswordWidget";
import {AddressDetailsWidget} from "../../../../components/accountDetails/AddressDetailsWidget";
import {getProductByPolicyNumber} from "../../../../CommonFunctions";

interface IPolicySummaryPageParams {
    policyNumber: string;
}

interface IPolicySummaryPageProps extends RouteComponentProps<IPolicySummaryPageParams> {}

interface IState {
    party?: Party,
    user?: User;
    policy?: Policy;
    mtaOnEndDateOfPolicy: boolean;
}

@authorize
export class AnnualAccountDetailsPage extends React.Component<IPolicySummaryPageProps, IState> {

    private pluginTemplates = new PluginTemplates();
    private product: ProductsEnum;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IPolicySummaryPageProps) {
        super(props);

        this.state = {
            mtaOnEndDateOfPolicy: false
        }

        this.product = getProductByPolicyNumber(this.props.match.params.policyNumber);
    }

    public componentDidMount() {
        {window.scrollTo(0, 0)}

        this.customerPortalService
            .getPolicy(this.props.match.params.policyNumber)
            .subscribe((policy: Policy) => {
                this.setState({
                    policy,
                    mtaOnEndDateOfPolicy: moment.utc(policy.endDate).isSame(moment.utc(policy.annualPolicyInfo.maxFutureMtaDate), 'day')
                });
        });

        this.customerPortalService.getProfile().subscribe((output: Party) => {
            const party: Party = output;

            this.setState({
                party
            })
        });

        this.customerPortalService.getUserById().subscribe((user: User) => {
            this.setState({
                user
            });
        });

        this.pluginTemplates.setPageTitle("Your account details");
    }


    public render(): React.ReactNode {
        const loading: boolean = !(this.state.party && this.state.policy && this.state.user);

        if (loading) {
            return  <Overlay show={true}/>;
        } else if (this.state.party && this.state.user && this.state.policy && this.state.policy.annualPolicyInfo) {
            return (
                <>
                    <FalconHeader/>
                    <div className="plugin account-details-container">
                        <FalconNavigatorHeader
                            back="/dashboard"
                            title="Account details"
                        />
                        <AccountDetailsBanner/>
                        <div className="plugin plugin-panel inner-container inner-content text-center account-details-section">
                            <div className="panel-detail-output-entity account-details-title p-0 icon-container">
                                <div>
                                    <img className="account-details-icon person-icon" alt="make-changes" src={`/${resourcesHelper.THEME}/img/account-details.png`}/>
                                </div>
                            </div>
                            <div>
                                <PersonalDetailsWidget party={this.state.party}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <ContactDetailsWidget party={this.state.party} hasIdp={this.state.party.hasIdp}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <AddressDetailsWidget addressChangeUrl={`/journey/show/product/PropositionWolfMotorInsurance/process/mtaChangeAddress/preset/${this.state.policy?.interaction._id}`}
                                                      allowAddressChange={!this.state.policy?.annualPolicyInfo.hasUnpaidChargebackInvoice}
                                                      futureMta={this.state.policy?.annualPolicyInfo.maxMtaDateReached}
                                                      mtaOnEndDateOfPolicy={this.state.mtaOnEndDateOfPolicy}
                                                      fullAddress={this.state.policy?.interaction.policyHolder.address.fullAddress}
                                                      coverCancelled={this.state.policy?.status === POLICY_STATUS_MTC}
                                />
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                {this.state.user && !this.state.party.hasIdp && <ChangePasswordWidget/>}
                            </div>
                        </div>
                        <AutomaticRenewalCheckboxSection
                            history={this.props.history}
                            activeAnnualPolicy={this.state.policy}
                            product={this.product}
                        />
                        {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/`)}
                    </div>
                    <FalconFooter/>
                </>
            )
        }

        return <></>
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/AnnualAccountDetailsPage.tsx